import AuthStorage from './auth.storage'
import LocaleStorage from './locale.storage'
export {
  AuthStorage,
  LocaleStorage
}


// WEBPACK FOOTER //
// ./src/storage/index.js